export default "__VITE_ASSET__DIn0HdHb__"